module.exports = __webpack_public_path__ + "static/baggage2-d78ed100cb95b0c863dbad50ec08b1c8.svg";